module.exports = __webpack_public_path__ + "img/personagem2.d39d3362.png";